import React, { Fragment, useState } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Chip from '@material-ui/core/Chip';

export const ChipSelect = (props) => {

    const { tags, setTags, searchAction, placeholder } = props;

    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const ref = React.createRef();
    const filterBy = () => true;

    const handleSearch = async (query) => {
        try {
            setIsLoading(true);
            const items = await searchAction(query);
            const options = items.map((item) => ({
                id: item.value,
                item: item.label
            }));
            setOptions(options);
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    }

    const onKeyDown = (e) => {
        if (e.keyCode === 13) {
            pushChips(e.target.value)
        }
    }

    const pushChips = (value) => {
        console.log(tags);
        if (value && tags === null) {
            setTags([value])
            if (ref && ref.current)
                ref.current.clear()
        } else if (value && !tags.includes(value)) {
            setTags([...tags, value])
            if (ref && ref.current)
                ref.current.clear()
        }
    }

    const handleDelete = (tagToDelete) => {
        const _tags = tags.filter((tag) => tag !== tagToDelete);
        setTags(_tags);
    };

    const renderTags = () => {
        return tags.map((t, i) => (
            <Chip
                className="mx-1 mb-2"
                key={i}
                label={t}
                onDelete={() => handleDelete(t)}
            />
        ))
    }

    return (
        <div className="row">
            <div className="col-12 mb-2">
                <AsyncTypeahead
                    ref={ref}
                    onChange={(e) => {
                        pushChips(e[0].item)
                    }}
                    allowNew
                    onKeyDown={onKeyDown}
                    filterBy={filterBy}
                    id="async-example"
                    isLoading={isLoading}
                    labelKey="item"
                    minLength={2}
                    onSearch={handleSearch}
                    options={options}
                    placeholder={placeholder}
                    renderMenuItemChildren={(option, props) => (
                        <Fragment>
                            <span>{option.item}</span>
                        </Fragment>
                    )}
                />
            </div>
            <div className="col-12">
                {tags ? renderTags() : null}
            </div>
        </div>
    )

}